import { Component, Input, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PanelMenu } from 'primeng/panelmenu';
import { IconComponent } from '@navstation-portal/shared/ui/components';
import { AppStore } from '@navstation-portal/reporting/data-access/app';
import { SideMenuItem } from '../side-menu-constants';

@Component({
  selector: 're-collapsed-panel-menu',
  templateUrl: './collapsed-panel-menu.component.html',
  styleUrl: './collapsed-panel-menu.component.css',
  imports: [
    FontAwesomeModule,
    RouterLink,
    PanelMenu,
    IconComponent,
    RouterLinkActive,
  ],
})
export class CollapsedPanelMenuComponent {
  @Input()
  routes: SideMenuItem[] = [];

  readonly appStore = inject(AppStore);

  getRouterLink(
    item: SideMenuItem,
  ): string | readonly unknown[] | null | undefined {
    const route = item.collapsedRoute ?? item.route;
    if (!route) return [];

    const routeParts = route.split('/');
    if (!routeParts) return [];

    const vesselId = this.appStore.selectedVesselId();
    if (vesselId) {
      routeParts.unshift(vesselId);
    }

    return routeParts;
  }
}
